import { IFramelyApi } from "../../../../findifyv2-api-ts/public/IframelyApi";

import { HTMLIframe, useHtmlIframeProps } from "@native-html/iframe-plugin";
import { useMemo, useState, useEffect } from "react";
import { extractAttributesFromHTML } from "../FindifyHTMLRender";
import * as LZString from 'lz-string';
import { Text } from "react-native";

export const IframeRenderersProps = {
    scalesPageToFit: true,
    webViewProps: {}
}

const IframelyHtmlBlock = ({ url, iframeProps, ...props }: any) => {
    const [code, setCode] = useState<JSX.Element>(<></>);
    const [error, setError] = useState<string | null>(null);
    const iframelyApi = useMemo(() => new IFramelyApi(), []);

    useEffect(() => {
        let cancelled = false;
        if (!url || typeof url !== 'string') {
            setCode(<></>);
            setError(null);
            return;
        }
        iframelyApi.iframely(url)
            .then((res) => {
                if (cancelled) return;
                if (!res || !res.data || !res.data.html) {
                    setError('Invalid response from Iframely API');
                    setCode(<Text>Invalid embedded content</Text>);
                    return;
                }
                try {
                    const attributes = extractAttributesFromHTML(res.data.html);
                    setCode(<HTMLIframe {...iframeProps} source={{ html: res.data.html }} htmlAttribs={attributes} />);
                    setError(null);
                } catch (parseError) {
                    console.error('HTML parsing error:', parseError);
                    setError('Failed to parse embedded content');
                    setCode(<Text>{url ?? 'Unknown URL'}</Text>);
                }
            })
            .catch((err) => {
                if (cancelled) return;
                console.error('Iframely API error:', err);
                setError(err.message || String(err) || 'Unknown error');
                // Fallback: show the URL as a text
                setCode(<Text>{url ?? 'Unknown URL'}</Text>);
            });
        return () => {
            cancelled = true;
        };
    }, [url, iframelyApi]);

    if (error) {
        return <Text>Error loading embedded content</Text>;
    }
    return code;
};

export const IframeRenderer = (props: any) => {
    const iframeProps = useHtmlIframeProps(props);

    const url = iframeProps.htmlAttribs['data-lexical-url'];
    const embedCode = iframeProps.htmlAttribs['data-lexical-embedcode'];
    const htmlCode = useMemo(() => {
        if (!embedCode) return '';
        return LZString.decompressFromEncodedURIComponent(embedCode) ?? '';
    }, [embedCode]);
    const htmlAttributes = useMemo(() => {
        if (!htmlCode) return {};
        return extractAttributesFromHTML(htmlCode);
    }, [htmlCode]);

    if (url) {
        return <IframelyHtmlBlock iframeProps={iframeProps} url={url} />
    } else if (embedCode) {
        // RETURN THIS
        return <HTMLIframe
            WebView={iframeProps.WebView}
            source={{
                html: htmlCode
            }}
            style={iframeProps.style}
            htmlAttribs={htmlAttributes}
            scaleFactor={1}
        />;
    }
    // Do customize the props here; wrap with your own container...
    return <HTMLIframe {...iframeProps} />;
};
